export const qs = (root, sel) => root.querySelector(sel);
export const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

export function scrollToFirstError (container, errorClass = 'error') {
    const first = container.querySelector(`.${errorClass}`);
    first?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}